<template lang="pug">
.row
  .centered-content(style="padding-bottom: 100px;")
    .page-header
      h1 Budgee benefits
      h2 All the cash flow superpowers you'll need to manage your business
      //p.page-header Budgee is software for managing cashflow for you small business. Accounting software only shows you what has already been invoiced, and often in a manner that is not useful at all in seeing what you have in your account. If you want to the freedom to see
      //.header-details
        p Relax and put your feet up. You've got this. We've spent years stressing over cash flow so we know how it can be. We thought that there must be a better way of planning things rather than drowning in ever more complex spreadsheets. And lucky you, we figured it out. 
        //.thing
          img(src="@/assets/images/features/relax.png")
        p We know that with the ability to rapidly create a forecast, share it with management, drag amounts around, run scenarios, zoom in on the extra tricky timeframes, that you will get the clarity you need to navigate your business through anything. Making it look easy.
    .centered-row
      .left-side
        .feature-text
          h1 Beautiful controls
          p 'Moving money' in budgee is more than a metaphor. Drag and drop budgeted amounts to quickly see what effect delaying a payment, or bringing forward a sale will have on your cash.
      .right-side
        .picture
          bw-picture-circles
          img(src="@/assets/images/features/dragging.gif")
    .centered-row
      .left-side
        .picture
          bw-picture-circles
          img(src="@/assets/images/features/scroll.gif")
      .right-side
        .feature-text
          h1 Unlimited view into the future
          p We all want to know how our business is doing now but wouldn’t it be fun to see where it could be in 3 months? 2 years? 10 years? Budgee lets you see what your business is doing now and will also help you to see and create your successful future.
    .centered-row
      .left-side
        .feature-text
          h1 Set scenarios to help you manage risks
          p Budgee's powerful scenario tools make it quick and easy to change amounts, hide amounts, and delay amounts. Create multiple scenarios and switch different ones on and off to work out the best plan moving forward.
      .right-side
        .picture
          bw-picture-circles
          img(src="@/assets/images/features/scenarios.png" style= "background: white; padding: 30px 80px;")
    .centered-row
      .left-side
        .picture
          bw-picture-circles
          img(src="@/assets/images/features/share.png" style="padding-right: 29px;background: white;height: 270px;object-fit: contain;padding-left: 18px;")
      .right-side
        .feature-text
          h1 Share visibility across the business
          p Budgee is here to bring people together, to help navigate the hard times and celebrate the good. Work together with Budgee by sharing your boards with view or edit permissions. Create successful scenarios with your partners that everyone can see live.
    .centered-row
      .left-side
        .feature-text
          h1 Day, week, month or year view of cash flows
          p Zoom in to see what details are going on day to day, week to week, or zoom out to see the bigger picture with what is going on month to month or even year to year. Finding the right resolution to manage your cash flow is half the battle.
      .right-side
        .picture
          bw-picture-circles
          img(src="@/assets/images/features/dates.gif")
    .centered-row(style="margin-bottom: 50px;")
      .left-side
        .picture
          bw-picture-circles
          img.icon-picture(src="@/assets/images/features/categories.png" style="padding: 20px 32px 0; margin: -30px 0;")  
      .right-side
        .feature-text
          h1 Categorise your cash
          p View your cash flow with all the amounts grouped by categories to get an overview of where your money is coming from and where it is going. Drill down to see the specific amounts.
    .centered-row
      .left-side
        .feature-text
          h1 Effortless accounts receivable and payable
          p Switch to the receivables view to see how much has come in this month and what is still to come in, switch to the payables view to see what has been paid and what is still to be paid.
      .right-side
        .picture
          bw-picture-circles
          img(src="@/assets/images/features/receivables.gif")
    .centered-row
      .left-side
        .picture
          bw-picture-circles
          img.icon-picture(src="@/assets/images/features/filter.png" style="padding: 0 30px; margin: -49px auto -188px; max-width: 380px; justify-self: center; display: flex;")
      .right-side(style= "padding-bottom: 50px;")
        .feature-text
          h1 Drill down with filters
          p See just the data you are interested in with powerful filters. Use filters to create to-do lists, see the effect of specific transactions, or see how much you are spending over time with a vendor. 
    .centered-row
      .left-side(style= "padding-bottom: 50px;")
        .feature-text
          h1 Easy sales tax forecasts
          p Budgee will work out your sales tax for you based on your forecast figures. No more guessing, or spending way too long on spreadsheets!
      .right-side
        .picture
          bw-picture-circles
          img.icon-picture(src="@/assets/images/features/forecast.png" style= "max-width: 450px; display: flex; justify-self: center; margin: -60px auto -49px;")
    .centered-row
      .left-side
        .picture
          bw-picture-circles
          img.icon-picture(src="@/assets/images/features/labels.png" style= "max-width: 480px; display: flex; justify-self: center; margin: -70px auto;")  
      .right-side
        .feature-text(style= "padding-bottom: 50px;")
          h1 Become a power user with labels
          p  Uses labels to mark cash flow urgent or overdue. Also create helpful tools such as to-do lists then delegate tasks to your fellow partners. Take labels a step further and run scenarios such as the likelihood of making sales, or experiment with levels of priority for payments. With budgee you can easily do what spreadsheets make near impossible!
    .centered-row
      .left-side(style= "padding-bottom: 70px;")
        .feature-text
          h1 Include your credit
          p If you have an overdraft or a credit card, budgee will not only show you how much cash you have left, it can show you how much funds you still have available too.
      .right-side
        .picture
          bw-picture-circles
          img.icon-picture(src="@/assets/images/features/credit.png" style= "max-width: 400px; display: flex; justify-self: center; margin: -70px auto;") 
</template>

<script>
import BwPictureCircles from "@/components/shared/BwPictureCircles";
export default {
  components: {
    BwPictureCircles
  }
};
</script>

<style lang="stylus" scoped>
@import "./../../assets/styles/mixins.styl"
.thing
  display: flex
  flex-direction: row
  img
    width: 50%
    display: flex
  p
    padding: 0 0 0 40px
    display: flex
    width: 50%



.row
  display: flex
  background: white//#f5f7f9
.centered-row
  display: flex
  flex-direction: row
  margin-bottom: 110px
.page-header
  text-align:center
  padding-bottom: 100px
  padding-top: 10px
  h2
    padding-bottom: 0
    margin-bottom: 5px

h1
  font-size: 36px
  line-height: 50px
  font-weight: 600
  color: rgba(0,0,0,0.79)
  margin-bottom: 10px
  margin-top: 0
h2
  font-size: 22px
  text-align: center
  font-weight: 300
  padding-bottom: 30px
h3
  font-size: 22px
p
  line-height: 30px
.left-side
  display: flex
  flex-direction: column
  width: 50%
  padding-right: 20px
.right-side
  display: flex
  width: 50%
  flex-direction: column
  padding-left: 20px
.picture
  margin: 0 auto
  height: auto
  width: 100%
  position: relative
  max-width: 600px
  img
    width: 100%
    border-radius: 10px
    box-shadow: 0 6px 6px -3px rgba(0,0,0,.05),0 10px 14px 1px rgba(0,0,0,.05),0 4px 18px 3px rgba(0,0,0,.05)
    position: relative
    z-index: 1
  img.icon-picture
    box-shadow: none

.feature-text
  z-index: 1
.left-side .picture
  //margin-right: 30px
.right-side .picture
  //margin-left: 30px
@media mq-tablet-wide
  .centered-content
    .centered-row:nth-child(odd)
      flex-direction: column
  .centered-row
    flex-direction: column-reverse

  .right-side, .left-side
    width: 100%
    display: flex
    align-items: center
    padding: 0
    margin: 0
    .picture
      margin: 0 0 0 0
  h1, p
    text-align: center
  h1:not(.page-header)
    font-size: 20px
    line-height: 30px
  h2.page-header
    padding-bottom: 50px
  p
    font-size: 16px
    line-height: 26px
    margin-top: 0
  h1.page-header
    padding-top: 20px !important
  .centered-row
    margin-bottom: 100px
</style>
